/**
 * StyleMetricsCard Component
 * Displays read-only style metrics (tone, formality, directness).
 */
import React from 'react';

interface StyleMetricsCardProps {
  tone: string | null;
  formality: string | null;
  directnessScore: number | null;
  avgCommentLength: number | null;
  onEdit: () => void;
}

const StyleMetricsCard: React.FC<StyleMetricsCardProps> = ({
  tone,
  formality,
  directnessScore,
  avgCommentLength,
  onEdit,
}) => {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium text-gray-900">Style Overview</h3>
        <button
          onClick={onEdit}
          className="text-sm text-blue-600 hover:text-blue-700"
        >
          Edit
        </button>
      </div>

      <div className="space-y-3">
        {/* Tone */}
        <div className="flex items-center justify-between">
          <span className="text-sm text-gray-500">Tone</span>
          <span className="text-sm font-medium text-gray-900">
            {tone || 'Not set'}
          </span>
        </div>

        {/* Formality */}
        <div className="flex items-center justify-between">
          <span className="text-sm text-gray-500">Formality</span>
          <span className="text-sm font-medium text-gray-900">
            {formality || 'Not set'}
          </span>
        </div>

        {/* Directness */}
        <div>
          <div className="flex items-center justify-between mb-1">
            <span className="text-sm text-gray-500">Directness</span>
            <span className="text-sm font-medium text-gray-900">
              {directnessScore !== null ? directnessScore.toFixed(1) : 'N/A'}
            </span>
          </div>
          {directnessScore !== null && (
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div
                className="bg-blue-600 h-2 rounded-full transition-all"
                style={{ width: `${directnessScore * 100}%` }}
              />
            </div>
          )}
        </div>

        {/* Average Length */}
        <div className="flex items-center justify-between">
          <span className="text-sm text-gray-500">Avg Length</span>
          <span className="text-sm font-medium text-gray-900">
            {avgCommentLength !== null ? `${avgCommentLength} words` : 'N/A'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default StyleMetricsCard;
